import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import Notice from '../views/Notice.vue'
import Document from '../views/Document.vue'

import { i18n } from '@/plugins/i18n'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/notice',
    name: 'Notice',
    component: Notice
  },
  {
    path: '/document',
    name: 'Document',
    component: Document
  },
  {
    path: '*',
    component: () => import('../views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: 'loan',
  routes
})

const empty = (value) => {
  if (value === null) return true
  if (typeof value === 'undefined') return true
  if (typeof value === 'string' && value === '') return true
  if (Array.isArray(value) && value.length < 1) return true
  if (typeof value === 'object' && value.constructor.name === 'Object' && Object.keys(value).length < 1 && Object.getOwnPropertyNames(value) < 1) return true
  if (typeof value === 'object' && value.constructor.name === 'String' && Object.keys(value).length < 1) return true // new String() return false
}

const getLang = (nation) => {
  let lang = ''
  if (nation === 'vn') {
    lang = 'vi'
  } else if (nation === 'np') {
    lang = 'ne'
  } else if (nation === 'mm') {
    lang = 'my'
  } else if (nation === 'uz') {
    lang = 'uz'
  } else if (nation === 'kh') {
    lang = 'kh'
  } else if (nation === 'kr') {
    lang = 'ko'
  } else if (nation === 'lk') {
    lang = 'lk'
  } else if (nation === 'ph') {
    lang = 'ph'
  } else if (nation === 'bd') {
    lang = 'bd'
  } else {
    lang = 'en'
  }
  return lang
}

router.beforeEach((to, from, next) => {
  let lang = ''
  const nation = to.query.nation

  if (empty(nation)) {
    lang = store.state.language.language
  }

  /* if (nation === 'ph' || nation === 'lk' || nation === 'bd') {
    lang = 'en'
  } else  */

  // lang = (store.state.language.language) ? store.state.language.language : lang
  if (store.state.language.language) {
    if (store.state.language.language !== lang) {
      lang = getLang(nation)
      /* if (nation === 'vn') {
        lang = 'vi'
      } else if (nation === 'np') {
        lang = 'ne'
      } else if (nation === 'mm') {
        lang = 'my'
      } else if (nation === 'uz') {
        lang = 'uz'
      } else if (nation === 'kh') {
        lang = 'kh'
      } else if (nation === 'kr') {
        lang = 'ko'
      } else {
        lang = 'en'
      } */
    } else {
      lang = store.state.language.language
    }
  } else {
    lang = getLang(nation)
  }

  console.log(lang)
  store.dispatch('language/setLanguage', lang)
    .then(() => {
      i18n.locale = store.state.language.language
      // console.log('after : ' + i18n.locale)
      // console.log('after : ' + store.state.language.language)
      next()
    })

  /* if (store.state.language.language && store.state.language.language !== i18n.locale) {
    console.log('a')
    i18n.locale = store.state.language.language
    next()
  } else if (!store.state.language.language) {
    console.log('b')
    store.dispatch('language/setLanguage', lang)
      .then(() => {
        i18n.locale = store.state.language.language
        next()
      })
  } else {
    console.log('c')
    next()
  } */

  // console.log(i18n.locale)
  // console.log(store.state.language.language)
})

export default router
